/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */
import { Button } from "@nordcloud/gnui";
import {
  CloudResourcesFilterByInput,
  CloudResourcesKeyValueFilterByInput,
  CloudResourcesRangeFilterByInput,
} from "~/generated/graphql";
import { isEmpty } from "~/tools";
import { useCreateCloudResourceReport } from "../../hooks/useCreateCloudResourceReport/useCreateCloudResourceReport";

type GenerateCloudResourceReportProps = {
  disabled?: boolean;
  filters: {
    filterBy?: CloudResourcesFilterByInput[];
    keyValueFilterBy?: CloudResourcesKeyValueFilterByInput[];
    rangeFilterBy?: CloudResourcesRangeFilterByInput[];
  };
  selectedResourceIDs: string[];
};

function GenerateCloudResourceReport({
  disabled,
  filters,
  selectedResourceIDs,
}: GenerateCloudResourceReportProps) {
  const [createCloudResourceReport, loading] = useCreateCloudResourceReport();

  const handleExport = () => {
    const mutationInput = {
      filters: isEmpty(selectedResourceIDs)
        ? {
            filterBy: filters.filterBy || [],
            keyValueFilterBy: filters.keyValueFilterBy || [],
            rangeFilterBy: filters.rangeFilterBy || [],
          }
        : undefined,
      resourceIds: selectedResourceIDs,
    };
    createCloudResourceReport(mutationInput);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={disabled || loading}
      severity="low"
      icon="download"
    >
      {"Get CSV Report"}
    </Button>
  );
}

export default GenerateCloudResourceReport;
